﻿/**
 * Cookiebot
 * Collection of actions for use with Cookiebot by the user
 * @package Shared
 */

export class Cookiebot {
    constructor() {
        this._refs = {
            renew: Array.from(document.querySelectorAll('.cookiebot-renew')),
            withdraw: Array.from(document.querySelectorAll('.cookiebot-withdraw'))
        }

        this._refs.renew.forEach(x => x.addEventListener('click', this._onRenewClick.bind(this)));
        this._refs.withdraw.forEach(x => x.addEventListener('click', this._onWithdrawClick.bind(this)));
    }

    /**
     * Renew consents given by user
     * @param {Event} e - Event Interface 
     */
    _onRenewClick(e) {
        e.preventDefault();

        if (typeof window.Cookiebot === 'undefined') {
            return false;
        }

        window.Cookiebot.renew();
    }

    /**
     * Withdraw all consents given by user
     * @param {Event} e - Event interface
     */
    _onWithdrawClick(e) {
        e.preventDefault();

        if (typeof window.Cookiebot === 'undefined') {
            return false;
        }

        window.Cookiebot.withdraw();
    }
}  